import React, { useEffect, useRef, useMemo } from 'react';
import { useSelector } from 'react-redux';
import L from 'leaflet';
import 'leaflet-editable';
import { useProjectMapContext } from './../../hooks/useProjectMapContext';
import useMapService from './../../hooks/useMapService';
import './custom-polyline.css';
import CustomMarkerTree from './CustomMarkerTree';

const CustomPolyline = ({ item }) => {
  const project = useSelector((state) => state.project);
  const { mapRef, setItemContextMenuOptions } = useProjectMapContext();
  const { setCurrentDrawingLayer } = useMapService();
  const polylineRef = useRef(null);
  const lastDrawingLayer = useRef(null);
  const color = item.itFeatures?.color || '#3583e9';
  const name = item.itName;
  const linePoints = item.itGeometry;
  const children = useMemo(() => (
    item.itType === 'alignment'
      ? project.items.filter(it => it.itParentId === item.itId)
      : []
  ), [project.items, item.itId, item.itType]);
  useEffect(() => {
    polylineRef.current = L.polyline(linePoints, {
      color,
      weight: 5,
      item: { itId: item.itId, itType: item.itType }
    }).addTo(mapRef.current);
    const eventHandlers = {
      click: (event) => {
        setItemContextMenuOptions({
          show: true,
          item: item,
          left: event.originalEvent.layerX - 20,
          top: event.originalEvent.layerY - 20,
          latlng: [event.latlng.lat, event.latlng.lng],
        });
        L.DomEvent.stopPropagation(event);
      },
      editableVertexDragend: () => {
        setCurrentDrawingLayer(polylineRef.current);
      }
    };

    polylineRef.current.on('click', eventHandlers.click);
    polylineRef.current.on('editable:vertex:dragend', eventHandlers.editableVertexDragend);
    return () => {
      polylineRef.current.off('click', eventHandlers.click);
      polylineRef.current.off('editable:vertex:dragend', eventHandlers.editableVertexDragend);
      if (mapRef.current && polylineRef.current) {
        mapRef.current.removeLayer(polylineRef.current);
      }
    };
  }, []);
  useEffect(() => {
    if (polylineRef.current) {
      polylineRef.current.setLatLngs(linePoints);
      polylineRef.current.setStyle({ color });
      if (polylineRef.current.getPopup()) {
        polylineRef.current.getPopup().setContent(name);
      } else {
        polylineRef.current.bindPopup(name);
      }
    }
  }, [linePoints, color, name]);

  return (
    <>
      {children.map(child => child.match_filters && (
        <CustomMarkerTree item={child} key={child.itId} />
      ))}
    </>
  );
};

export default CustomPolyline;
